import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import throttle from 'lodash.throttle';
import rootReducer from '../reducers';
import rootSaga from '../sagas';
import { saveState } from './localStorage';

export default function configureStore(environment, browserHistory, initialState) {
  const dev = environment === 'development';

  const routerMiddleweare = routerMiddleware(browserHistory);
  const sagaMiddleware = createSagaMiddleware();

  const middlewares = compose(
    applyMiddleware(thunk, sagaMiddleware, routerMiddleweare),
    dev && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : f => f
  );

  const store = createStore(rootReducer(browserHistory), initialState, middlewares);

  store.subscribe(
    throttle(() => {
      saveState(store.getState());
    }, 1000)
  );

  sagaMiddleware.run(rootSaga);

  if (dev && module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      store.replaceReducer(rootReducer(browserHistory));
    });
  }
  return store;
}
